import {Loader} from "@googlemaps/js-api-loader";
import Server from "../server";

const server = Server.instance();

export const Map_ = new Promise((resolve, reject) => {

    server.getMapsAPIKey().then((apiKey) => {

        const loader = new Loader({
            apiKey: apiKey,
            version: "weekly",
        });

        loader.load().then(async () => {
            const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
            resolve(Map);
        }).catch(reject);
    }).catch(reject);
});

export const Places_ = new Promise((resolve, reject) => {

    server.getMapsAPIKey().then((apiKey) => {

        const loader = new Loader({
            apiKey: apiKey,
            version: "weekly",
        });

        loader.load().then(async () => {
            const PlacesLibrary = await google.maps.importLibrary("places") as google.maps.PlacesLibrary;
            resolve(PlacesLibrary);
        }).catch(reject);
    }).catch(reject);
});

export const Visualization_ = new Promise((resolve, reject) => {

    server.getMapsAPIKey().then((apiKey) => {

        const loader = new Loader({
            apiKey: apiKey,
            version: "weekly",
        });

        loader.load().then(async () => {
            const PlacesLibrary = await google.maps.importLibrary("visualization") as google.maps.VisualizationLibrary;
            resolve(PlacesLibrary);
        }).catch(reject);
    }).catch(reject);
});

export const Markers_ = new Promise((resolve, reject) => {

    server.getMapsAPIKey().then((apiKey) => {

        const loader = new Loader({
            apiKey: apiKey,
            version: "weekly",
        });

        loader.load().then(async () => {
            const MarkerLibrary = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
            resolve(MarkerLibrary);
        }).catch(reject);
    }).catch(reject);
});

